/**
 * Tradução dos erros do GoTrue para chaves de mensagem.
 *
 * A regra que decide o que dizer e o que calar:
 *
 * **"Confirme seu e-mail" é dito.** Revela que a conta existe, mas o GoTrue já
 * responde de forma diferente nesse caso — esconder na interface não esconde
 * nada de quem sabe olhar a resposta HTTP, e o custo de não dizer é a pessoa
 * ficar sem saída. Aconteceu no primeiro teste real do produto.
 *
 * **"E-mail não existe" e "senha errada" viram a mesma frase.** Aí a distinção
 * não ajuda quem é dono da conta, e transformaria a tela de login num
 * verificador de cadastro para quem não é.
 */

import { AuthError, AuthRetryableFetchError } from '@supabase/auth-js';

const BY_CODE: Record<string, string> = {
  invalid_credentials: 'auth:error.invalidCredentials',
  email_not_confirmed: 'auth:error.notConfirmed',
  over_request_rate_limit: 'auth:error.rateLimited',
  over_email_send_rate_limit: 'auth:error.rateLimited',
  weak_password: 'auth:error.weakPassword',
  same_password: 'auth:error.weakPassword',
  otp_expired: 'auth:reset.invalidTitle',
  validation_failed: 'auth:error.generic',
};

export function authErrorKey(error: unknown): string {
  // Falha de rede tem chave própria: a pessoa pode estar na academia, sem
  // sinal, e "e-mail ou senha incorretos" mandaria conferir o que está certo.
  if (error instanceof AuthRetryableFetchError) return 'errors:network_unreachable';

  if (error instanceof AuthError) {
    const mapped = error.code ? BY_CODE[error.code] : undefined;
    if (mapped) return mapped;
    // Versões mais antigas do GoTrue não mandam `code`; a mensagem é o que há.
    if (/not confirmed/i.test(error.message)) return 'auth:error.notConfirmed';
    if (/invalid login/i.test(error.message)) return 'auth:error.invalidCredentials';
  }

  return 'auth:error.generic';
}
